export { Seniorsidentificationmanager } from "./seniorsidentificationmanager";
